var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("こんにちは、"+_vm._s(_vm.user.lastName + _vm.user.firstName)+" さん")]),_c('label',[_c('button',{staticClass:"logout",on:{"click":_vm.logout}},[_vm._v("ログアウト")])])])}
var staticRenderFns = []

export { render, staticRenderFns }